import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Loader } from 'components/Loader';

import { PlanogramForm } from './PlanogramForm';

import {
    LocationPlanogramFragmentFragment,
    useGetAllProductsQuery,
    useGetMicrostoreSitesWithLocationsInfoQuery,
    useGetSiteLocationPlanogramsQuery,
} from 'data/__generated__';

type ParamTypes = {
    siteId: string;
};

const tomorrowDate = new Date();
tomorrowDate.setDate(tomorrowDate.getDate() + 1);

export const MicrostorePlanogram = () => {
    const { siteId = '' } = useParams<ParamTypes>();

    const {
        loading: microstoreSitesLoading,
        data: microstoreSitesData,
        error: microstoreSitesError,
    } = useGetMicrostoreSitesWithLocationsInfoQuery({ variables: { siteIds: [siteId] } });

    const {
        loading: locationPlanogramsLoading,
        data: locationPlanogramsData,
        error: locationPlanogramsError,
    } = useGetSiteLocationPlanogramsQuery({ variables: { siteId } });

    const {
        loading: productsLoading,
        data: productsData,
        error: productsError,
    } = useGetAllProductsQuery({ fetchPolicy: 'no-cache' });

    if (microstoreSitesLoading || productsLoading || locationPlanogramsLoading) {
        return (
            <Container>
                <Loader />
            </Container>
        );
    }

    if (
        microstoreSitesError ||
        !microstoreSitesData ||
        productsError ||
        !productsData ||
        locationPlanogramsError ||
        !locationPlanogramsData
    ) {
        throw new Error('Une erreur est survenue lors de la récupération du plano');
    }

    const { sites } = microstoreSitesData;
    const { getSiteLocationPlanograms: locationPlanograms } = locationPlanogramsData;
    const { getAllProducts: products } = productsData;

    const [site] = sites;

    const locationPlanogramsByDate: Record<string, LocationPlanogramFragmentFragment[]> = {};
    locationPlanograms.forEach((locationPlanogram) => {
        if (!locationPlanogramsByDate[locationPlanogram.startDate]) {
            locationPlanogramsByDate[locationPlanogram.startDate] = [];
        }
        locationPlanogramsByDate[locationPlanogram.startDate].push(locationPlanogram);
    });

    if (!site) {
        throw new Error('Une erreur est survenue lors de la récupération du plano');
    }

    return <PlanogramForm locationPlanogramsByDate={locationPlanogramsByDate} products={products} site={site} />;
};

const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
    overflow: hidden;
`;
